define(['backbone'], (Backbone) => Backbone.Model.extend({
    defaults: {
        name: ''
    }

}));
